// extracted by mini-css-extract-plugin
export var children = "ModuleLayout-module--children--bd07e";
export var contentContainer = "ModuleLayout-module--contentContainer--a7903";
export var moduleContainer = "ModuleLayout-module--moduleContainer--89bc7";
export var subtitle = "ModuleLayout-module--subtitle--f9784";
export var text = "ModuleLayout-module--text--658c0";
export var title = "ModuleLayout-module--title--51762";
export var titleAndTextContainer = "ModuleLayout-module--titleAndTextContainer--07e28";
export var titleDivider = "ModuleLayout-module--titleDivider--55e12";
export var withoutMarginAfterTitle = "ModuleLayout-module--withoutMarginAfterTitle--74d58";